export interface LocalStorageService<T> {
  get: () => T | null;
  set: (key: T) => void;
  clear: () => void;
}

export class DefaultLocalStorageService<T = string>
  implements LocalStorageService<T>
{
  constructor(private readonly key: string) {}

  get = (): T | null => {
    return localStorage.getItem(this.key) as T | null;
  };

  set = (value: T) => {
    localStorage.setItem(this.key, value as string);
  };

  clear = () => {
    localStorage.removeItem(this.key);
  };
}

export class JsonLocalStorageService<T> implements LocalStorageService<T> {
  constructor(
    private readonly key: string,
    private readonly reviver?: (key: string, value: any) => any
  ) {}

  get = (): T | null => {
    const item = localStorage.getItem(this.key);
    if (!item) {
      return null;
    }
    return JSON.parse(item, this.reviver) as unknown as T;
  };

  set = (value: T) => {
    localStorage.setItem(this.key, JSON.stringify(value));
  };

  clear = () => {
    localStorage.removeItem(this.key);
  };
}
